
    import './styles.scoped.css';
    export default {
  "alert": "awsui_alert_mx3cw_1jw5w_13",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_mx3cw_1jw5w_1",
  "root": "awsui_root_mx3cw_1jw5w_56",
  "hidden": "awsui_hidden_mx3cw_1jw5w_91",
  "alert-wrapper": "awsui_alert-wrapper_mx3cw_1jw5w_147",
  "initial-hidden": "awsui_initial-hidden_mx3cw_1jw5w_159",
  "header": "awsui_header_mx3cw_1jw5w_164",
  "header-replacement": "awsui_header-replacement_mx3cw_1jw5w_165",
  "action": "awsui_action_mx3cw_1jw5w_169",
  "action-slot": "awsui_action-slot_mx3cw_1jw5w_173",
  "action-button": "awsui_action-button_mx3cw_1jw5w_174",
  "alert-focus-wrapper": "awsui_alert-focus-wrapper_mx3cw_1jw5w_178",
  "text": "awsui_text_mx3cw_1jw5w_210",
  "icon": "awsui_icon_mx3cw_1jw5w_217",
  "message": "awsui_message_mx3cw_1jw5w_220",
  "action-wrapped": "awsui_action-wrapped_mx3cw_1jw5w_224",
  "icon-size-medium": "awsui_icon-size-medium_mx3cw_1jw5w_228",
  "icon-size-big": "awsui_icon-size-big_mx3cw_1jw5w_232",
  "icon-size-normal": "awsui_icon-size-normal_mx3cw_1jw5w_236",
  "content": "awsui_content_mx3cw_1jw5w_240",
  "content-replacement": "awsui_content-replacement_mx3cw_1jw5w_241",
  "dismiss": "awsui_dismiss_mx3cw_1jw5w_245",
  "dismiss-button": "awsui_dismiss-button_mx3cw_1jw5w_251",
  "type-error": "awsui_type-error_mx3cw_1jw5w_255",
  "type-warning": "awsui_type-warning_mx3cw_1jw5w_263",
  "type-success": "awsui_type-success_mx3cw_1jw5w_271",
  "type-info": "awsui_type-info_mx3cw_1jw5w_279"
};
  